export const validLocation = (location: { lat: number; lon: number }) => {
  if (!location) return false;
  return location.lat !== 0 && location.lon !== 0;
};
